package org.solyton.solawi.bid.module.user.action.organization

import org.evoleq.compose.Markup
import org.evoleq.math.contraMap
import org.evoleq.optics.storage.Action
import org.evoleq.optics.transform.times
import org.solyton.solawi.bid.module.user.data.Application
import org.solyton.solawi.bid.module.user.data.api.organization.ApiOrganizations
import org.solyton.solawi.bid.module.user.data.api.organization.ReadOrganizations
import org.solyton.solawi.bid.module.user.data.transform.toDomainType
import org.solyton.solawi.bid.module.user.data.user
import org.solyton.solawi.bid.module.user.data.user.organizations

const val READ_ORGANIZATIONS = "ReadOrganizations"

@Markup
fun readOrganizations(): Action<Application, ReadOrganizations, ApiOrganizations> = Action(
    name = READ_ORGANIZATIONS,
    reader = { ReadOrganizations },
    endPoint = ReadOrganizations::class,
    writer = (user * organizations.set) contraMap {
        organizations: ApiOrganizations -> organizations.toDomainType()
    }
)
